export const DISPATCH_DESTINATIONS = [
  { id: 'outlet', label: 'Outlet' },
  { id: 'internal_packing', label: 'Internal Packing' },
  { id: 'customer', label: 'Customer' },
  { id: 'warehouse', label: 'Warehouse' },
  { id: 'vendor', label: 'Vendor' },
  { id: 'stakeholder', label: 'Stakeholder', optional: true },
  { id: 'other', label: 'Other', optional: true },
];

export const groupDispatchDestinations = (orders) => {
  const groups = Object.fromEntries(DISPATCH_DESTINATIONS.map(({ id }) => [id, []]));
  orders.forEach(order => {
    const type = String(order?.destination || '').split(':')[0].trim().toLowerCase();
    const group = Object.prototype.hasOwnProperty.call(groups, type) ? type : 'other';
    groups[group].push(order);
  });
  return groups;
};
